import React from "react";



const Android = () => {
return(
    
<>

<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">Android</div>
<h3>Hire the best Android app Developers in Mumbai<br/>
<span>You do not want to be left behind in a market that has globally established its worth. Hire ShellCode Solutions, the best Android app developers in Mumbai, to cater to your Android development needs.<br/>
Custom Hiring Models<br/>
On-Time delivery<br/>
Dexterous development methodology<br/>
Source Code Authorization<br/>
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>Android Development Services we provide:<br/>
    <span>
    Native Android App Development: We utilize technologies such as C, C++, Android Studio, and HTML to offer you the best Android Apps for your brand.<br/>
Upgradation and Migration: We keep your app updated on various Android Versions and ensure that migration is hassle-free.<br/>
UI and UX: We build an interactive and responsive user interface and enhance User Experience to make your app aesthetically pleasing.<br/>
QA and Testing: We always ensure that your app is ready to take on the world by conducting various rounds of testing. We hate bugs more than you do!<br/>
Wearable Applications: We build wearables of the desired customization and oversee and improve functionality to guarantee user satisfaction.<br/>
App Support and Maintenance: We realize that your app needs further care and offer you constant maintenance and support in case you need it.<br/>
    </span></h3>
    
    <h3>Why hire ShellCode Solutions, the best Android App developers in Mumbai?<br/>
    
    <span>
    We create opportunities for you in the form of the best Android app you will ever see. Here’s how:<br/>
Focused Team: Our dedicated team of developers pays great attention to detail and does not compromise on the quality of your app.<br/>
Economical Rates: We provide robust Android app development services at prices that are easy on your pocket.<br/>
Dedicated workforce: Our developers work dexterously to provide quality solutions to you in the form of the best Android app.<br/>
Customized solutions: We offer custom app development to ensure that your project gets proper attention and time.<br/>
Flexibility: Our development process is flexible to incorporate your vision and ideas. We realize your dream into reality.<br/>
Privacy and Security: We provide safe and secure solutions to ensure that you get the best!
    <br/></span>
    </h3>
    <h3>Best Android App Development in Mumbai across industries<br/>
    <span>Android apps are a hit in the market, irrespective of the industry they cater to. We realize this and offer our services across all industries.</span></h3>

    <h3>Technologies and Tools We use<br/>
    <span>We utilize state-of-the-art technology to give you the best Android app of all time!
<br/>
    </span>
    </h3>
    <h3>Customizable packages for your requirements<br/>
    <span>To serve a specific purpose, an app has to be developed in a specific manner. No one gets it better than we do!<br/>
    </span>
    </h3>
    

   
</div>
    </>
)
}

export default Android;
